import produce from "immer";
import {MODE_TYPE} from "utils/constants";

const initialState = {
  studioMode: MODE_TYPE.EDIT_MODE,
  publishMode: MODE_TYPE.SINGLEPLAY_MODE,
};

const mode = (state = initialState, action) => {
  const {payload} = action;

  switch (action.type) {
    case MODE_TYPE.CHANGE_MODE:
      return produce(state, draft => {
        draft.studioMode = payload;
      });
    case MODE_TYPE.CHANGE_PUBLISH_MODE:
      return produce(state, draft => {
        draft.publishMode = payload;
      });
    default:
      return state;
  }
};

export default mode;
